import axios from 'axios'

import {types} from '../../actions'

export const post_request = {
    methods:{
        post_request(data){

            data.reward_reservation_uid = this.$store.state.uid

            axios.post(this.$store.state.API_ROUTE + this.$store.state.stages[this.$store.state.active_view].all.methods.post.url, data)
              .then((response) => {

                this.$store.dispatch(types.FIND_AND_SAVE,response)
                this.$store.commit('save_optional_data',{type:'post',data: response.data.data})

                this.redirect(response.data.redirect_to)

              })
              .catch((error) => {
                  this.show_errors(error)
                  console.log(error)
              });

        }
    },
    created(){},
    mounted(){

    }
}